module.exports = __webpack_public_path__ + "static/showcase-pics-2843c652f9888fb12a867651c4cf2eaa.jpg";